<template>
  <div class="task_container">
    <cv-navbar/>

    <div class="container_main flex">
      <div class="select-container">
        <div class="select-item">
          <span>订单ID：</span>
          <el-input v-model="filterParams.order_id" clearable placeholder="请填写" size="small" style="width: auto;"/>
        </div>
        <div class="select-item">
          <span>面试辅导：</span>
          <el-select v-model="filterParams.interview_guidance" clearable placeholder="请选择" size="small">
            <el-option
              v-for="item in selectOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="select-item">
          <span>面试模拟：</span>
          <el-select v-model="filterParams.interview_simulation" clearable placeholder="请选择" size="small">
            <el-option
              v-for="item in selectOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="select-item">
          <span>简历代投：</span>
          <el-select v-model="filterParams.resume_submission" clearable placeholder="请选择" size="small">
            <el-option
              v-for="item in selectOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="select-item">
          <span>特惠月卡：</span>
          <el-select v-model="filterParams.discount_monthly_card" clearable placeholder="请选择" size="small">
            <el-option
              v-for="item in selectOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="select-item">
          <span>简历优化：</span>
          <el-select v-model="filterParams.cv_optimization" clearable placeholder="请选择" size="small">
            <el-option
              v-for="item in selectOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="select-item">
          <span>职业规划：</span>
          <el-select v-model="filterParams.career_plan" clearable placeholder="请选择" size="small">
            <el-option
              v-for="item in selectOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="select-item">
          <span>套餐：</span>
          <el-select v-model="filterParams.plan" clearable placeholder="请选择" size="small">
            <el-option
              v-for="item in plan_desc_list"
              :key="item.key"
              :label="item.label"
              :value="item.key">
            </el-option>
          </el-select>
        </div>
        <div class="select-item">
          <span>完成时间：</span>
          <el-date-picker
            v-model="filterTime"
            type="daterange"
            range-separator="至"
            @change="timeChange()"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="left"
            value-format="yyyy-MM-ddT00:00:00Z"
            size="small">
          </el-date-picker>
        </div>
        <div class="select-item">
          <el-button type="primary" size="small" @click="searchDataList()">搜索</el-button>
        </div>
      </div>
      <div class="main_tab mar-t-12">
        <div class="tab_con">
          <!--                    <p class="item_0 pointer" @click="$router.push('/mentor/tasks/statement')">账单</p>-->
          <!--                    <p class="item_1 pointer" @click="active = '全部'">全部</p>-->
          <p class="item_2 pointer" @click="assigned()">进行中</p>
          <p class="item_3 pointer" @click="doneData()">已完成</p>
        </div>
      </div>
      <div class="table pad-t-12">
        <div class="main_table_1">
          <el-table :data="tableData" stripe border v-loading="loadingState"
                    :header-cell-style="{background:'rgb(245,245,247)',color:'rgb(125,125,126)'}"
                    style="background-color: transparent;color: rgb(125,125,126);">
            <el-table-column prop="mentor_order_id" min-width="50" label="订单编号" width="50%">
            </el-table-column>
            <el-table-column prop="userName" min-width="36" label="姓名">
              <template slot-scope="scope">
                <span>{{ scope.row.user_info['name'] ? scope.row.user_info['name'] : '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="phone" min-width="80" label="联系方式">
              <template slot-scope="scope">
                <span>{{ scope.row.order_info['phone'] || scope.row.user_info['contact'] || scope.row.user_info['phone'] || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="cv_name" min-width="50" label="文件名称">
              <template slot-scope="scope">
                <span
                  v-if="scope.row.order_info['cv_optimization']">{{ scope.row.cv_name ? scope.row.cv_name : '未上传简历' }}</span>
                <span v-else>{{ scope.row.cv_name ? scope.row.cv_name : '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="plan" min-width="36" label="套餐">
              <template slot-scope="scope">
                <span>{{ plan_desc[scope.row.order_info['plan']] || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="求职身份">
              <template slot-scope="scope">
                <span>{{ scope.row.job_identity_desc || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="order_info.mentor_type" min-width="36" label="语言类型">
              <template slot-scope="scope">
                <span
                  v-if="typeof(scope.row.order_info['cv_lang'])=='number'">{{ cv_lang[scope.row.order_info['cv_lang']] }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="urgency" min-width="60" label="紧急程度">
              <template slot-scope="scope">
                <span
                  :style="{color: urgency[scope.row.order_info['urgency']] == '加急' ? 'red' : 'rgb(125, 125, 126)'}">{{ urgency[scope.row.order_info['urgency']] }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="" min-width="36" label="工作年限">
              <template slot-scope="scope">
                <span v-if="scope.row.order_info['work_year']">{{ workYear[scope.row.order_info['work_year']] }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column> -->
            <el-table-column prop="" min-width="36" label="最高学历">
              <template slot-scope="scope">
                <span>{{ degree[scope.row.order_info.degree] || '-' }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="" min-width="36" label="是否有海外经历">
              <template slot-scope="scope">
                <span>{{ !scope.row.job_identity_desc ? (scope.row.order_info.mentor_type === 'en' ? '是' : '否') || '-' : '-' }}</span>
              </template>
            </el-table-column> -->
            <el-table-column prop="industry" min-width="36" label="行业">
              <template slot-scope="scope">
                <span>{{ profession[scope.row.order_info['industry']] || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="interview_guidance" min-width="36" label="面试辅导">
              <template slot-scope="scope">
                <span>{{ scope.row.order_info.interview_guidance ? '是' : '否' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="interview_simulation" min-width="36" label="职业咨询">
              <template slot-scope="scope">
                <span>{{ scope.row.order_info.interview_simulation ? '是' : '否' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="resume_submission" min-width="36" label="简历代投">
              <template slot-scope="scope">
                <span>{{ scope.row.order_info['resume_submission'] ? '是' : '否' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="discount_monthly_card" min-width="36" label="特惠月卡">
              <template slot-scope="scope">
                <span>{{ scope.row.order_info['discount_monthly_card'] ? '是' : '否' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="cv_optimization" min-width="36" label="简历优化">
              <template slot-scope="scope">
                <span>{{ scope.row.order_info['cv_optimization'] ? '是' : '否' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="" min-width="36" label="职业规划">
              <template slot-scope="scope">
                <span>{{ scope.row.order_info.career_plan ? '是' : '否' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="change_profession" min-width="36" label="是否转行">
              <template slot-scope="scope">
                <span>{{ scope.row.order_info.change_profession ? '是' : '否' }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="" min-width="36" label="瑕疵修复">
              <template slot-scope="scope">
                <span>{{ !scope.row.job_identity_desc ? (scope.row.order_info.defect_repair ? '是' : '否') : '-' }}</span>
              </template>
            </el-table-column> -->
            <!--                      v-if="isShowPrice"-->
            <el-table-column prop="price" min-width="60" label="订单价格" align="center">
              <template slot-scope="scope">
                <span>￥</span><br>
                <span>{{ scope.row.price / 100 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="state" min-width="36" label="状态">
              <template slot-scope="scope">
                <el-link v-if="(scope.row.state===0 || scope.row.state===1) && scope.row.order_info.aasm_state !== 'refund'" type="primary" @click="jump(scope.row)">
                  {{ itemState[scope.row.state] }}
                </el-link>
                <span v-else>{{ itemState[scope.row.state] }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="order_info.aasm_state" min-width="40" label="订单状态">
            </el-table-column>
            <el-table-column prop="created_at" min-width="60" label="创建于">
              <template slot-scope="scope">
                <!--                                <span>{{scope.row.created_at.replace(/\T|Z/g," ")}}</span>-->
                <span>{{ scope.row.created_at.split("T")[0] }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="" min-width="60" label="更新于">
              <template slot-scope="scope">
                <!--                                <span>{{scope.row.updated_at.replace(/\T|Z/g," ")}}</span>-->
                <span>{{ scope.row.updated_at.split("T")[0] }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="finished_at" min-width="60" label="完成于" v-if="state==='done'">
              <template slot-scope="scope">
                <span>{{ scope.row.finished_at ? scope.row.finished_at.split("T")[0] : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="countdown" min-width="60" label="任务倒计时">
              <template slot-scope="scope">
                <div v-if="scope.row.order_info.aasm_state === 'refund'">
                  <span>已完成（退款）</span>
                </div>
                <div v-else-if="scope.row.state===2">
                  <span>任务已完成</span>
                </div>
                <div v-else-if="scope.row.state===3">
                  <span>任务自动完成</span>
                </div>
                <div v-else-if="scope.row.state===1">
                  <span>等待学员反馈</span>
                </div>
                <div v-else>
                  <div v-if="isDateOver(scope.row.countdown)" style="color: orange">
                    <span>剩余</span>
                    <span
                      v-if="dateTimes(scope.row.countdown).day > 0">{{ dateTimes(scope.row.countdown).day }}天</span>
                    <span
                      v-if="dateTimes(scope.row.countdown).hour > 0">{{ dateTimes(scope.row.countdown).hour }}小时</span>
                  </div>
                  <div v-else style="color: red">
                    <span>逾期</span>
                    <!--                                        <span v-if="dateTimes(scope.row.countdown).day > 0">{{dateTimes(scope.row.countdown).day}}天</span>-->
                    <!--                                        <span v-if="dateTimes(scope.row.countdown).hour > 0">{{dateTimes(scope.row.countdown).hour}}小时</span>-->
                    <!--                                        <span v-if="dateTimes(scope.row.countdown).min > 0">{{dateTimes(scope.row.countdown).min}}分钟</span>-->
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="state" min-width="60" label="操作" v-if="state==='assigned'">
              <template slot-scope="scope">
                <div v-if="scope.row.state===2 || scope.row.state===3">-</div>
                <div v-else>
                  <el-link type="primary" @click="complete(scope.row.id, scope.$index)">结束任务</el-link>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pages mar-t-12">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="10"
            :current-page.sync="page.curPage"
            :total="page.total"
            @current-change="curChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import cvNavbar from '@/components/base/navbar';
import pcFooter from '@/components/base/pcFooter';
import api from '@/api'
import {mapState} from 'vuex'

export default {
  components: {
    cvNavbar,
    pcFooter
  },
  data() {
    return {
      // isShowPrice: false,
      loadingState: false,
      state: 'assigned',
      tableData: [],
      page: {
        total: 0,
        curPage: 1
      },
      // 简历语言
      cv_lang: {
        0: '中文',
        1: '英文',
        2: '中英双语'
      },
      // 工作年限
      workYear: {
        4: '1年及以下',
        5: '2年',
        6: '3年',
        7: '4年',
        8: '5年',
        9: '6年',
        10: '7年',
        11: '8年',
        12: '8年以上'
      },
      // 行业
      profession: ['互联网技术', '医疗/制药', '金融/咨询/四大', '互联网非技术', '快消/贸易', '广告/传媒', '教育/培训', '房地产/建筑',
        '其他', 'it', '央国企（含银行）'],
      // 紧急程度
      urgency: ["正常", "加急", "加急"],
      plan_desc_list: [
        {key: 'intern', label: '实习版'},
        {key: 'campus', label: '校招版'},
        {key: 'full', label: '在职版'}
      ],
      // 套餐类型
      plan_desc: {
        "intern": '实习版',
        "campus": '校招版',
        "full": '在职版',
        "app_student": "app-实习版",
        "app_novice": "app-校招版",
        "app_elite": "app-在职版",
        "app_bilingual": "app中英文简历",
        "app_coach": "app面试辅导",
        "app_plan": "app职业规划"
      },
      // 状态
      itemState: {
        0: '未反馈',
        1: '已反馈',
        2: '已完成',
        3: '任务自动完成'
      },
      selectOptions: [
        {value: 1, label: '是'},
        {value: 2, label: '否'}
      ],
      filterTime: [],
      filterParams: {
        interview_guidance: '',   // 面试辅导
        interview_simulation: '',   // 职业咨询
        cv_optimization: '',   // 简历优化
        career_plan: '',   // 职业规划
        resume_submission: '',   // 简历代投
        discount_monthly_card: '',   // 特惠月卡
        plan: '',    // 导师辅导套餐
        start_at: '',    // 完成时间筛选
        end_at: '',
        order_id: ''
      },
      mentor_type: {
        "cn": "国内导师",
        "en": "海外经历导师"
      },
      degree: {
        "undergraduate": "本科及以下",
        "master": "硕士及以上"
      }
    }
  },
  computed: {
    ...mapState('me', ['personInfo']),
    // 是否显示订单价格
    isShowPrice() {
      return this.personInfo.id && this.personInfo.id === 4876927;
    }
  },
  created() {
    this.getMentorList()
  },
  methods: {
    timeChange() {
      // 筛选时间参数
      if (this.filterTime.length > 0) {
        this.filterParams.start_at = this.filterTime[0]
        this.filterParams.end_at = this.filterTime[1]
      } else {
        this.filterParams.start_at = ''
        this.filterParams.end_at = ''
      }
    },
    // 进行中
    assigned() {
      this.page.curPage = 1;
      this.state = 'assigned';
      this.getMentorList();
    },
    // 已完成
    doneData() {
      this.page.curPage = 1;
      this.state = 'done';
      this.getMentorList();
    },
    // 是否逾期
    isDateOver(date) {
      let nextDate = Date.parse(new Date(date));
      let now = Date.parse(new Date());
      if (nextDate > now) {
        return true
      } else {
        return false
      }
    },
    // 计算剩余时间
    dateTimes(date) {
      let nextDate = Date.parse(new Date(date));
      let now = Date.parse(new Date());
      if (nextDate > now) {
        let cha = (nextDate - now) / 1000;
        let day = Math.floor(cha / 86400);
        let hour = Math.floor((cha - (86400 * day)) / 3600);
        let min = Math.floor((cha - (86400 * day + 3600 * hour)) / 60);
        let sec = cha - (86400 * day + 3600 * hour + min * 60);
        return {day: day, hour: hour, min: min, sec: sec}
      } else {
        let cha = (now - nextDate) / 1000;
        let day = Math.floor(cha / 86400);
        let hour = Math.floor((cha - (86400 * day)) / 3600);
        let min = Math.floor((cha - (86400 * day + 3600 * hour)) / 60);
        let sec = cha - (86400 * day + 3600 * hour + min * 60);
        return {day: day, hour: hour, min: min, sec: sec}
      }
    },
    // 跳转简历页
    jump(obj) {
      // console.log(obj, "================》order_info.aasm_state")
      // const { order_info: { aasm_state } } = obj
      // if (aasm_state === 'refund') return
      // window.location.href = `${window.location.origin}/mentor/cvs/${obj.cv_token}/editor`
      window.open(`${window.location.origin}/mentor/cvs/${obj.cv_token}/editor`)
    },
    searchDataList() {
      // 列表数据筛选
      this.page.curPage = 1;
      this.getMentorList()
    },
    // 当前页改变
    curChange(index) {
      this.page.curPage = index;
      this.getMentorList()
    },
    // 获取导师列表
    getMentorList() {
      this.tableData = [];
      this.loadingState = true;
      // this.state = doOrNot;
      let params = {type: this.state, page: this.page.curPage, size: 10, ...this.filterParams}
      // console.log(params,"===================>params")
      api.mentor.getMentorList(params).then((res) => {
        if (res.code === 1000) {
          this.page.total = res.data.total_counts;
          this.tableData = res.data.result;
          this.loadingState = false;
        } else {
          this.$message({
            type: 'warning',
            message: res.message
          })
        }
      })
    },
    handleClick(ref) {
      console.log(ref)
    },
    //完成订单
    complete(task_id, index) {
      this.$confirm('即将提前结束该订单，操作后不可恢复，确认结束吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.mentorOrders.putTaskComplete(task_id).then(res => {
          if (res.code === 1000) {
            this.tableData[index].state = 2
            this.$message({
              type: 'success',
              message: '订单已结束!'
            });
          }
        })

      }).catch(() => {

      });
    },
  }

}
</script>

<style lang="scss">
.pages {
  display: flex;
  justify-content: center;

  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
    border: 1px solid #ccc;
  }

  .el-pagination.is-background .btn-next.disabled, .el-pagination.is-background .btn-next:disabled, .el-pagination.is-background .btn-prev.disabled, .el-pagination.is-background .btn-prev:disabled, .el-pagination.is-background .el-pager li.disabled {
    border-color: #ccc;
    opacity: 0.7;
  }

  .el-pagination.is-background .el-pager li:not(.disabled).active {
    border-color: rgb(247, 100, 47);
    background-color: rgb(247, 100, 47);
  }
}

.table {
  .main_table_1 {
    .el-table--border::after, .el-table--group::after, .el-table::before {
      background-color: #ddd !important;
    }

    .el-table--border,
    .el-table--group {
      border-color: #ddd !important;
    }

    .el-table td,
    .el-table th.is-leaf {
      border-bottom: 1px solid #ddd;
    }

    .el-table--border th,
    .el-table--border th.gutter:last-of-type {
      border-bottom: 1px solid #ddd;
    }

    .el-table--border td,
    .el-table--border th {
      border-right: 1px solid #ddd;
    }
  }
}
</style>

<style lang="scss" scoped>
.display {
  display: block;
}

.task_container {
  margin-top: 56px;
  width: 100%;
  height: 100%;
  background-color: rgb(245, 245, 247);

  .container_main {
    //overflow: hidden;
    //margin: 0 auto;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    padding: 0 40px;
    min-width: 1220px;
    flex-wrap: wrap;

    .select-container {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 12px;

      .select-item {
        margin-left: 10px;
        margin-top: 10px;

        &:first-child {
          //margin-left: 0;
        }
      }
    }

    //background-color: blueviolet;
    .main_tab {
      display: flex;
      justify-content: flex-end;
      //float: right;
      width: 100%;
      height: 28px;
      line-height: 28px;
      //background-color: bisque;
      text-align: center;

      .tab_con {
        width: auto;
        overflow: hidden;
        border-radius: 4px;
        display: flex;

        p {
          color: #fff;
          font-size: 14px;
          font-weight: 600px;
        }

        p:nth-child(1) {
          width: 50px;
          background-color: rgb(247, 100, 47);
        }

        p:nth-child(2) {
          width: 50px;
          background-color: orangered;
        }

        p:nth-child(2) {
          width: 60px;
          background-color: rgb(163, 47, 4);
        }

        p:nth-child(4) {
          width: 60px;
          background-color: rgb(247, 100, 47);
        }

        p:hover {
          opacity: 0.8;
        }
      }
    }

    .table {
      width: 100%;
      //margin-top: 40px;
      .main_table_1 {

      }
    }
  }


}
</style>
